import React from 'react';

const CoffeeIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='M6 25h18v-2H6m18-11h-2V9h2m0-2H8v10a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4v-3h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z'
      fill='currentColor'
      fillRule='nonzero'
    />
  </svg>
);

export default CoffeeIcon;
